import axiosInstance from "../axiosInterceptor";

export async function getStory() {
    const response = await axiosInstance.get(`student/getStory`);
    const data = response?.data;
    return data;
}
